import { EmbedTheme } from '../../../services/storefrontService';

export type EmbedMode = 'script' | 'iframe';

/** Origin der API (ohne `/api`), von dort kommen `embed-loader.js` und die Widget-Endpunkte. */
export const embedApiOrigin = (): string => {
    const raw = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    return raw.replace(/\/+$/, '').replace(/\/api$/, '');
};

const attr = (value: string): string => value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');

/**
 * HTML-Snippet für die Host-Seite. `script`: Widget wird direkt in die Seite
 * gerendert (Origin-Freigabe nötig). `iframe`: Der Loader bettet eine
 * eigenständige Seite ein und passt die Höhe automatisch an.
 */
export const buildEmbedSnippet = (token: string, theme: EmbedTheme, mode: EmbedMode, lang?: string): string => {
    const origin = embedApiOrigin();
    const langAttr = lang ? ` data-lang="${attr(lang)}"` : '';
    const modeAttr = mode === 'iframe' ? ' data-mode="iframe"' : '';
    return `<script src="${origin}/embed-loader.js" defer></script>\n<div data-oa-widget data-token="${attr(token)}" data-theme="${theme}"${modeAttr}${langAttr}></div>`;
};
